import React from 'react';
import { Check } from 'lucide-react';

export const PLATFORM_OPTIONS = [['olaparty', 'Olaparty (Qwick Live)'], ['trumeet', 'Trumeet']];

export const PlatformAccess = ({ value, onChange, options = PLATFORM_OPTIONS, testid = 'platform-access', size = 'md' }) => {
    const list = value || options.map(o => o[0]);
    const toggle = (k) => onChange(list.includes(k) ? list.filter(x => x !== k) : [...list, k]);
    const pad = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1.5 text-sm';
    return (
        <div className="flex flex-wrap gap-1.5" data-testid={testid}>
            {options.map(([k, label]) => {
                const on = list.includes(k);
                return (
                    <button key={k} type="button" onClick={() => toggle(k)} data-testid={`${testid}-${k}`} aria-pressed={on}
                        className={`inline-flex items-center gap-1 rounded-full border font-medium transition-colors ${pad} ${on ? 'border-[#1F9D8A] bg-[#1F9D8A]/10 text-[#0E6B5E]' : 'border-border text-muted-foreground hover:bg-secondary'}`}>
                        {on && <Check className="h-3 w-3" />}{label}
                    </button>
                );
            })}
        </div>
    );
};
